(function($){
  
$(document).ready(function() {
    var $dropdown = $('.site-nav__dropdown');
    var $navItem = $('#site-nav-item--2');

    // Função para abrir o menu
    function openMenu() {
         $('#site-nav-item--2').attr('open', 'open');
         $('#site-nav-item--2').data('hover', 'true');
    }

    // Função para fechar o menu
    function closeMenu() {
      $('#site-nav-item--2').removeAttr('open', 'open');
      $('#site-nav-item--2').data('hover', 'false');
    }

    // Eventos para o botão de navegação
    $navItem.on({
        click: function(event) {
            event.preventDefault(); // Impede o comportamento padrão do clique
            openMenu();
        },
        mouseenter: function() {
            openMenu();
        },
        mouseleave: function() {
            // Não feche imediatamente, permitindo que o usuário passe o mouse para o menu
        }
    });

    // Eventos para o dropdown
    $dropdown.on({
        mouseenter: function() {
            openMenu();
        },
        mouseleave: function() {
            // Não feche imediatamente, permitindo que o usuário passe o mouse para o botão
        }
    });

    // Adiciona um atraso ao fechar o menu para permitir a transição do mouse entre o botão e o menu
    $navItem.add($dropdown).on('mouseleave', function() {
        var $this = $(this);
        setTimeout(function() {
          const isHovered = $dropdown.is(':hover') || $navItem.is(':hover');
          console.log('hovered', $this.is(':hover'), isHovered);
            if (!isHovered) {
                closeMenu();
            }
        }, 200); // 400ms de atraso, ajustável conforme necessário
    });
});
  
})(jQuery);